import { formatPrice, type LocaleIso } from 'utils';
import { formatArticleScale, getArticleScalePrice } from './getArticleScalePrice';

interface LiveArticlePriceParams {
  /** RSC/SSR formatted price — used when the live total cannot be formatted. */
  price: string;
  /** RSC/SSR graduated price info — kept until the first live PSI response arrives. */
  scale: ReturnType<typeof formatArticleScale>;
  /** summaryPriceGross from the setAmount PSI response; undefined until the quantity was changed. */
  articlePrice: number | undefined;
  /** summaryPriceGrossScaled from the same response. */
  articlePriceScaled: number | undefined;
  /** Live total of the child articles (details). */
  detailsPrice: number;
  isScalable: boolean;
  locale: LocaleIso;
}

/**
 * Live price view values of an article card.
 * The PSI response is authoritative: the discount may appear or vanish when the quantity crosses a threshold.
 */
export function getLiveArticlePrice({
  price,
  scale,
  articlePrice,
  articlePriceScaled,
  detailsPrice,
  isScalable,
  locale
}: LiveArticlePriceParams) {
  if (articlePrice === undefined) {
    return { liveValue: undefined, scale };
  }

  const scalePrice = isScalable ? getArticleScalePrice(articlePrice, articlePriceScaled ?? 0) : null;
  const total = scalePrice?.scaledTotal ?? articlePrice + detailsPrice;

  return { liveValue: formatPrice(total, locale) ?? price, scale: formatArticleScale(scalePrice, locale) };
}
